import React from 'react';
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "oidc-react";
import { BenefitType } from "../enums/BenefitType";
import { Party } from "../enums/Party";

const VerifyEmailSent = () => {
    const location = useLocation();
    const params = useParams();
    const auth = useAuth();
    const benefitType = params?.coverage as BenefitType;
    const party = params?.party as Party;
    const emailAddress = (location.state as { emailAddress?: string } | null)?.emailAddress ?? 'your email address';

    if (auth?.userData) {
        return <Navigate to={`/${benefitType}/${party}`} replace />;
    }

    return (
        <div className="pds-u-text-align-center pds-u-padding-top-20 pds-u-padding-bottom-40">
            <div>Link has been successfully sent to <strong>{emailAddress}</strong></div>
            <div>You will receive an email from <strong>SBDCLAIMS@principal.com</strong> with the subject line <strong>Principal claims login</strong>.</div>
            <br />
            <div>Please check your inbox for details.</div>
        </div>
    )
};
export default VerifyEmailSent;